import { JsonObject, JsonProperty } from 'json2typescript';
import * as uuid from 'uuid';

import { FatcaManagerCompanyInterface, FatcaManagerCompanyRelation } from '../../../core';
import { FatcaManagerCompanyRelationAdapter } from '../../client/helpers/serializer/adapters/fatca-manager-company-relation.adapter';
import { Id } from './id';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('FatcaManagerCompany')
export class FatcaManagerCompany implements FatcaManagerCompanyInterface {
    private readonly _id: Id = undefined;

    @JsonProperty('CompanyName', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('ControlType', FatcaManagerCompanyRelationAdapter, true)
    private _relation: FatcaManagerCompanyRelation = undefined;


    constructor() {
        this._id = Id.fromString(uuid.v4());
    }

    get id(): Id {
        return this._id;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get relation(): FatcaManagerCompanyRelation {
        return this._relation;
    }

    set relation(value: FatcaManagerCompanyRelation) {
        this._relation = value;
    }

    isComplete(): boolean {
        return !!this.name &&
            !!this.relation;
    }
}
